import { render, staticRenderFns } from "./ClientLogo.vue?vue&type=template&id=028fb5be&scoped=true&"
import script from "./ClientLogo.vue?vue&type=script&lang=js&"
export * from "./ClientLogo.vue?vue&type=script&lang=js&"
import style0 from "./ClientLogo.vue?vue&type=style&index=0&id=028fb5be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028fb5be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
